<div class="mx-auto bg-{{ background }}-800 max-w-screen-sm lg:max-w-full">
  @for (block of items; track block; let i = $index) {
    <div
      class="transition-opacity duration-400 ease-linear delay-100 opacity-0"
      [ngClass]="index === i ? 'opacity-100' : ''"
    >
      @if (index === i) {
        <app-block-factory [blockId]="block.block"> </app-block-factory>
      }
    </div>
  }
</div>
